import * as actions from './actions'
import produce from 'immer'

const initialState = {
  loading: false,
  error: null,
  projectConnectionsSummary: {}
}

const projectConnectionsSummaryLoad = draft => {
  draft.loading = true
  draft.error = null
  draft.projectConnectionsSummary = {}
}

const projectConnectionsSummaryLoaded = (draft, action) => {
  draft.loading = false
  draft.error = null
  draft.projectConnectionsSummary = action.projectConnectionsSummary
}

const projectConnectionsSummaryLoadFail = (draft, action) => {
  draft.loading = false
  draft.error = action.error
  draft.projectConnectionsSummary = {}
}

const reducer = (state = initialState, action) => {
  return produce(state, draft => {
    switch (action.type) {
      case actions.PROJ_CONN_SUMMARY_LOAD_SAGA:
        return projectConnectionsSummaryLoad(draft)
      case actions.PROJ_CONN_SUMMARY_LOADED:
        return projectConnectionsSummaryLoaded(draft, action)
      case actions.PROJ_CONN_SUMMARY_LOAD_FAILURE:
        return projectConnectionsSummaryLoadFail(draft, action)
      default:
        return state
    }
  })
}

export { reducer }
